const sortingServices = angular.module('sortingServices', []);

sortingServices.service('arraySortService', function ($http, config) {

  function sortArrayWithKey(arr, key, ascending) {
    return arr.sort((a, b) => {
        if (a[key] === b[key]) {
          return 0;
        } else if (a[key] === null) {
          return ascending ? -1 : 1;
        } else if (b[key] === null) {
          return ascending ? 1 : -1;
        }

        return a[key] < b[key] ? (ascending ? 1 : -1) : (ascending ? -1 : 1);
    });
  }

  function sortArrayWithMappedValues(arr, key, ascending, valueMap) {
    return arr.sort((a, b) => {
      let aValue = valueMap[a[key]];
      let bValue = valueMap[b[key]];
      if (aValue === bValue) {
        return 0;
      } else if (aValue === null) {
        return ascending ? -1 : 1;
      } else if (bValue === null) {
        return ascending ? 1 : -1;
      }

      return aValue < bValue ? (ascending ? 1 : -1) : (ascending ? -1 : 1);
    });
  }

  function sortArrayWithInnerValue(arr, obj, key, ascending) {
    return arr.sort((a, b) => {
        
        if (a[obj][key] === b[obj][key]) {
          return 0;
        } else if (a[obj][key]  === null) {
          return ascending ? -1 : 1;
        } else if (b[obj][key]  === null) {
          return ascending ? 1 : -1;
        }

        return a[obj][key] < b[obj][key] ? (ascending ? 1 : -1) : (ascending ? -1 : 1);
    });
  }

  return {
    sortArrayWithKey: sortArrayWithKey,
    sortArrayWithMappedValues: sortArrayWithMappedValues,
    sortArrayWithInnerValue : sortArrayWithInnerValue
  };
});
